import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const UploadModal = ({ show, handleClose, handleUpload, fileName }) => {
  const [file, setFile] = React.useState(null);

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (file) {
      handleUpload(file);
      setFile(null);
    }
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Upload {fileName}</ModalHeader>
      <ModalBody>
        <Form onSubmit={onSubmit}>
          <FormGroup>
            <Label>Selecteer bestand</Label>
            <Input type="file" onChange={onFileChange} accept=".pdf" />
          </FormGroup>
          <div className="mt-3">
            <Button type="submit" color="primary" disabled={!file}>
              Upload
            </Button>{" "}
            <Button type="button" color="secondary" onClick={handleClose}>
              Annuleren
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default UploadModal;
